<div class="modal-form-background">
  <div class="container">
    <mat-drawer-container
      id="modal-form-drawer-container"
      class="modal-drawer-container"
      [hasBackdrop]="true"
      (backdropClick)="onBackdropClick()">
      <mat-drawer
        id="drawer"
        #drawer
        mode="over"
        position="end"
        [disableClose]="true"
        (closed)="onClose()">
        <ng-content select="[form]"></ng-content>
      </mat-drawer>
      <mat-drawer-content>
        <ng-content select="[router]"></ng-content>
      </mat-drawer-content>
    </mat-drawer-container>
  </div>
</div>
